// MON INITIALE PARIS — Scripts

let PRODUCT_VARIANTS = [];

function switchImage(src, thumb) {
  const img = document.getElementById('mainImg');
  if (img) img.src = src;
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  if (thumb) thumb.classList.add('active');
}

function selectOption(btn, optionName, value) {
  const parent = btn.closest('.size-row');
  parent.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  updateVariant();
}

function extractLetterCount(text) {
  const match = text.match(/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

function updateVariant() {
  const selected = [];
  document.querySelectorAll('.size-row').forEach(row => {
    const active = row.querySelector('.size-btn.active');
    selected.push(active ? active.textContent.trim() : null);
  });

  const addBtn = document.querySelector('.add-cart-btn');
  const buyBtn = document.querySelector('.buy-now-btn');
  const variantIdInput = document.getElementById('variantId');
  const priceMain = document.querySelector('.price-main');
  const engraveInput = document.getElementById('engraveText');
  const engraveHint = document.getElementById('engraveHint');

  const letterOption = selected.find(s => s && s.match(/\d+\s*Lettre/i));
  const letterCount = letterOption ? extractLetterCount(letterOption) : null;
  if (engraveInput && letterCount) {
    engraveInput.maxLength = letterCount;
    if (engraveHint) engraveHint.textContent = 'Maximum ' + letterCount + ' caractère' + (letterCount > 1 ? 's' : '') + '.';
  }

  if (!PRODUCT_VARIANTS.length) return;

  const match = PRODUCT_VARIANTS.find(v => {
    return v.options.length === selected.length && v.options.every((opt, i) => opt === selected[i]);
  });

  if (match && match.available) {
    if (variantIdInput) variantIdInput.value = match.id;
    if (priceMain) priceMain.textContent = formatMoney(match.price);
    if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Ajouter au panier'; }
    if (buyBtn) buyBtn.style.display = '';
  } else if (match && !match.available) {
    if (variantIdInput) variantIdInput.value = match.id;
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Rupture de stock'; }
    if (buyBtn) buyBtn.style.display = 'none';
  } else {
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Choisissez une option'; }
    if (buyBtn) buyBtn.style.display = 'none';
  }
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + '\u20ac';
}

function toggleAcc(trigger) {
  const body = trigger.nextElementSibling;
  const isOpen = body.classList.contains('open');
  document.querySelectorAll('.acc-body').forEach(b => b.classList.remove('open'));
  document.querySelectorAll('.acc-trigger').forEach(t => t.classList.remove('open'));
  if (!isOpen) {
    body.classList.add('open');
    trigger.classList.add('open');
  }
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.style.opacity = '1';
      e.target.style.transform = 'translateY(0)';
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.product-card, .collection-card, .testimonial-card').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(20px)';
  el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
  observer.observe(el);
});

document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.getElementById('product-json');
  if (dataEl) {
    try {
      PRODUCT_VARIANTS = JSON.parse(dataEl.textContent);
      updateVariant();
    } catch (e) { console.error('Erreur produit JSON', e); }
  }
});
